module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SAM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SAM001))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM002) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM003) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM004) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid
    }, [_c('td', {
      staticClass: "text-left"
    }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM005) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperId))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM006) + " (" + _vm._s(_vm.lang.SAM007) + "):\n                    "), _c('b', [_vm._v(_vm._s(proposal.DisplayName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM008) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Gender))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM009) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Distance) + " km")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (proposal.Profession),
        expression: "proposal.Profession"
      }]
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM010) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Profession))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM011) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarModelName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM012) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarSegmentName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM013) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperCar))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM014) + ":\n                    "), _c('b', [(proposal.CarMatch === '-') ? _c('span', [_vm._v("- " + _vm._s(_vm.lang.SAM015))]) : (proposal.CarMatch === '=') ? _c('span', [_vm._v("= " + _vm._s(_vm.lang.SAM016))]) : (proposal.CarMatch === '+') ? _c('span', [_vm._v("+ " + _vm._s(_vm.lang.SAM017))]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM018) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.LastUpdatedAt))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.globals.isLeadAgencyUser) ? _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Agency')
        }
      }
    }, [_vm._v(_vm._s(_vm.lang.SAM019))]), _vm._v(" "), (proposal.LastCommentLeadLocal) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadLocalCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(
      proposal.LastCommentLeadLocal,
      120
    )) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Audi')
        }
      }
    }, [_vm._v(_vm._s(_vm.globals.isAudiUser ? _vm.lang.SAM021 : _vm.lang.SAM020))]), _vm._v(" "), (proposal.LastCommentLeadAudi) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadAudiCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(
      proposal.LastCommentLeadAudi,
      120
    )) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.AgencyApprovalStatus),
        expression: "proposal.AgencyApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.AgencyApprovalStatus === 'Approved',
        'option-red': proposal.AgencyApprovalStatus === 'Rejected',
        'option-yellow': !proposal.AgencyApprovalStatus,
      },
      attrs: {
        "disabled": !_vm.globals.isAgencyUser ||
          proposal.MainEntityApprovalStatus
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "AgencyApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'leadAgency')
        }]
      }
    }, [_c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.MainEntityApprovalStatus),
        expression: "proposal.MainEntityApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.MainEntityApprovalStatus === 'Approved',
        'option-red': proposal.MainEntityApprovalStatus === 'Rejected',
        'option-yellow': !proposal.MainEntityApprovalStatus,
      },
      attrs: {
        "disabled": !_vm.globals.isAudiUser ||
          proposal.AgencyApprovalStatus !== 'Approved'
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "MainEntityApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'mainEntity')
        }]
      }
    }, [(
      !_vm.anyShopperAlreadyApproved ||
      proposal.MainEntityApprovalStatus === 'Approved'
    ) ? _c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SAM025) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d82dd8ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ShopperApprovalModal.vue
// module id = 659
// module chunks = 1 2